//#region src/loyalty_in_payment_options_mode.ts
const LoyaltyInPaymentOptionsMode = {
	Passive: "passive",
	PromptIfLoggedIn: "prompt-if-logged-in",
	AlwaysPrompt: "always-prompt",
	AlwaysPromptWithLoginOptions: "always-prompt-with-login-options",
	PromptInstantEnroll: "prompt-instant-enroll"
};
//#endregion
export { LoyaltyInPaymentOptionsMode };

//# sourceMappingURL=loyalty_in_payment_options_mode.js.map